import Vue from 'vue';
import Component from 'vue-class-component';
import {ProductViewport, PartProductOverviewport, Viewport} from '../../models/Viewport';
import {Language, ProductVersion} from '../../models/ProductModels';
import {getVersionUrl} from '../../models/UtilService';
import { version } from 'punycode';

@Component({
    props:{
        viewport:{
            
        }
    }
})
export default class VersionSelectDropdown extends Vue{
    
    hrefValue:string="";
    viewport;
    versionTitle:string="";
    
    versionChanged(){
        window.location.href=this.hrefValue;
    }

    
    getVersURL(version: ProductVersion):string{
        return getVersionUrl(version, this.viewport);
    }


    getVersURLForProdversion(productVersion: ProductVersion, lang: Language, prodName: string):string{
        return productVersion.spaceUrl
    }


    getVersionTitle():string{
        return this.versionTitle;
    }

    concatProdNameAndVersion(prodName:string, version:string):string
    {
        if(this.viewport.spaceProperty.spaceType=='SERVICE_PACK')
        {
            return version; 
        }
        else{
            return prodName+' '+version;
        }
    }

    created(){
        //console.log("VIEWPORT-->CURRENT_VERSION: ", (<ProductViewport>this.viewport).currentVersion);
        let version:ProductVersion =(<ProductViewport>this.viewport).currentVersion;
       
       // console.dir(this.viewport);
        this.versionTitle = this.concatProdNameAndVersion(this.viewport.spaceProperty.prod,version.version);
        if(!this.versionTitle)
        {
            throw('Fatal Error. No product version found');
        }

        this.hrefValue = this.getVersURL(version); 
    }
}
